/**
 * @ComponentFor CountryLinkBlockViewModel
 */
import React from 'react';
import { post, pushState, replaceState, currentUrl } from '@polarnopyret/scope';
import BlockPropType from './CountryLinkBlockViewModel.type';
import { styled } from '@glitz/react';
import Link from 'Shared/Link';
import { setCountryCode } from 'TrackingInformation';
import * as style from 'Shared/Style';

type PropType = BlockPropType;

const StyledLink = styled(Link, {
  display: 'inline',
  color: style.colors.monochrome.a11ygrey,
  ':hover': {
    textDecoration: 'underline',
  }
});

class CountryLinkBlock extends React.Component<PropType> {
  onSelectCountry = async () => {
    const { isExternalUrl, url, countryCode } = this.props;

    if (!isExternalUrl) {
      const urlx = currentUrl();
      const returnUrl = urlx.searchParams.get("returnUrl");
      const setMarketUrl = urlx.origin + urlx.pathname + '/setmarket?country=' + countryCode.toLowerCase() + (returnUrl ? '&returnUrl=' + returnUrl : '');
      try {
        const validation = await post(setMarketUrl);
        const result = await validation.json();

        // set country code in data layer
        setCountryCode(countryCode);

        //replaceState(result.url, { includeAppShellData: true }, false);
        window.nukeAppShellData();
        //window.location.reload();
        window.location.href = result.url;
      } catch (error) { }
    }
    else {
      window.location.href = url;
    }
  };

  render() {
    const { englishName, nativeName, url } = this.props;
    return (
      <StyledLink
        onClick={async (e) => {
          e.preventDefault();
          this.onSelectCountry();
        }}
        to={url}
      >
        <span>{englishName}</span> | <span>{nativeName}</span>
      </StyledLink >
    );
  }
}

export default CountryLinkBlock;
